import Consts from 'Framework/Consts';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { HttpPutService } from 'Shared/HttpServices/Services/HttpPutService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const OrdersHttpConfig = createAxiosHttpConfig({ baseURL: Consts.env.REACT_APP_ORDERS_APP_BASE_URL });

export const OrdersHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: OrdersHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const OrdersHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: OrdersHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });

export const OrdersHttpPutService = async (props: IHttpPostServiceProps) =>
  HttpPutService({
    API: OrdersHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });
